import { useState } from "react";


function Select(props) {
    const [showError, setShowError] = useState(false);

    function blurHandler(e) {
        const { value } = e.target;
        if (props.required) {
            if (value === '') {
                setShowError(true);
                let inputErrors = [...props.inputErrors];
                inputErrors[props.index] = 'error';
                props.setInputErrors(inputErrors);
            } else {
                setShowError(false);
                let inputErrors = [...props.inputErrors];
                inputErrors[props.index] = '';
                props.setInputErrors(inputErrors);
            }
        }
    }

    return (
        <>
            <div className="flex flex-col gap-2 w-full">
                <div className="flex flex-row items-center gap-1">
                    {props.required === true && <span className="text-danger text-sm font-semibold">*</span>}
                    {props.label && <label className="text-sm font-semibold text-neutral-700">{props.label}</label>}
                </div>
                <select
                    data-testid={props.testId || ''}
                    name={props.name}
                    value={props.value}
                    className={props.className || 'rounded-lg px-4 py-2.5 outline-none border border-neutral-300 bg-white w-full text-sm text-neutral-700 focus:border-primary focus:ring-2 focus:ring-primary-light transition-all shadow-sm hover:border-neutral-400 cursor-pointer'}
                    required={props.required}
                    onChange={(e) => props.onChange(e)}
                    onBlur={(e) => blurHandler(e)}
                >
                    {!props.value && <option value={''}>Select {props.placeHolder}</option>}
                    {
                        props.options.map((op, ind) => <option key={ind} value={props.valueKey ? op[props.valueKey] : op}>{props.nameKey ? op[props.nameKey] : op}</option>)
                    }
                </select>
            </div>
            <div className="text-danger text-xs font-semibold px-1 mt-1">
                {
                    (showError || (props.required && props.missingFields.includes(props.name))) && 'Required field!'
                }
                {
                    props.name === 'currency' && props.value?.length > 0 && !props.validCurrency.includes(props.value) && `Only ${props.validCurrency} is valid`
                }
            </div>
        </>
    )
}

export default Select;